/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDirectoryUserGroupDTO
 */
export interface ControlDirectoryUserGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    directoryUserId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUserGroupDTO
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    group: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupChatOpsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupContainmentEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupRuleSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupRuleSearchField?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupSlug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUserGroupDTO
     */
    groupSourceSystemUpdates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUserGroupDTO
     */
    overriddenByUser: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    overriddenByUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    overriddenByUserIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUserGroupDTO
     */
    teamId: string;
}

/**
 * Check if a given object implements the ControlDirectoryUserGroupDTO interface.
 */
export function instanceOfControlDirectoryUserGroupDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "directoryUserId" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "group" in value;
    isInstance = isInstance && "groupId" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "overriddenByUser" in value;
    isInstance = isInstance && "overriddenByUserId" in value;
    isInstance = isInstance && "overriddenByUserIdentifier" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlDirectoryUserGroupDTOFromJSON(json: any): ControlDirectoryUserGroupDTO {
    return ControlDirectoryUserGroupDTOFromJSONTyped(json, false);
}

export function ControlDirectoryUserGroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDirectoryUserGroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'directoryUserId': json['directoryUserId'],
        'enabled': json['enabled'],
        'group': json['group'],
        'groupChatOpsEnabled': !exists(json, 'groupChatOpsEnabled') ? undefined : json['groupChatOpsEnabled'],
        'groupContainmentEnabled': !exists(json, 'groupContainmentEnabled') ? undefined : json['groupContainmentEnabled'],
        'groupId': json['groupId'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'groupRuleSearch': !exists(json, 'groupRuleSearch') ? undefined : json['groupRuleSearch'],
        'groupRuleSearchField': !exists(json, 'groupRuleSearchField') ? undefined : json['groupRuleSearchField'],
        'groupSlug': !exists(json, 'groupSlug') ? undefined : json['groupSlug'],
        'groupSourceSystemUpdates': !exists(json, 'groupSourceSystemUpdates') ? undefined : json['groupSourceSystemUpdates'],
        'id': json['id'],
        'overriddenByUser': json['overriddenByUser'],
        'overriddenByUserId': json['overriddenByUserId'],
        'overriddenByUserIdentifier': json['overriddenByUserIdentifier'],
        'teamId': json['teamId'],
    };
}

export function ControlDirectoryUserGroupDTOToJSON(value?: ControlDirectoryUserGroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'directoryUserId': value.directoryUserId,
        'enabled': value.enabled,
        'group': value.group,
        'groupChatOpsEnabled': value.groupChatOpsEnabled,
        'groupContainmentEnabled': value.groupContainmentEnabled,
        'groupId': value.groupId,
        'groupName': value.groupName,
        'groupRuleSearch': value.groupRuleSearch,
        'groupRuleSearchField': value.groupRuleSearchField,
        'groupSlug': value.groupSlug,
        'groupSourceSystemUpdates': value.groupSourceSystemUpdates,
        'id': value.id,
        'overriddenByUser': value.overriddenByUser,
        'overriddenByUserId': value.overriddenByUserId,
        'overriddenByUserIdentifier': value.overriddenByUserIdentifier,
        'teamId': value.teamId,
    };
}

